// extracted by mini-css-extract-plugin
export default {"container":"AZ-z","list":"BZ-z"};